import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "innerbox"
};
const _hoisted_2 = {
  class: "imgTxtbox"
};
const _hoisted_3 = {
  key: 0,
  class: "imgbox"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "txtbox"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "textover"
};
const _hoisted_8 = {
  class: "textover"
};
const _hoisted_9 = {
  class: "textover"
};
const _hoisted_10 = {
  class: "popinnerbox"
};
const _hoisted_11 = {
  class: "pophead"
};
const _hoisted_12 = {
  class: "phleft"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "popcontent"
};
const _hoisted_15 = {
  class: "popconleft"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "popconright"
};
const _hoisted_18 = {
  key: 0,
  class: "imgbox"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "txtbox"
};
const _hoisted_21 = {
  class: "textcontainer"
};
const _hoisted_22 = ["innerHTML"];
const _hoisted_23 = {
  class: "ullist"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  key: 0,
  class: "imgbox"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "txtbox"
};
const _hoisted_28 = ["innerHTML"];
const _hoisted_29 = {
  class: "bigSwiper"
};
const _hoisted_30 = {
  class: "swiper-container swiperbox",
  ref: "bigswiper"
};
const _hoisted_31 = {
  class: "swiper-wrapper",
  id: "showBigswiper"
};
const _hoisted_32 = ["src"];
const _hoisted_33 = {
  class: "smallSwiper"
};
const _hoisted_34 = {
  class: "swiper-container swiperbox",
  ref: "smallswiper"
};
const _hoisted_35 = {
  class: "swiper-wrapper"
};
const _hoisted_36 = ["src"];
const _hoisted_37 = {
  class: "videoBox"
};
const _hoisted_38 = ["src"];
const _hoisted_39 = {
  class: "smallSwipervideo"
};
const _hoisted_40 = {
  class: "swiper-container swiperbox",
  ref: "videosmallswiper"
};
const _hoisted_41 = {
  class: "swiper-wrapper"
};
const _hoisted_42 = {
  class: "ullist style1"
};
const _hoisted_43 = {
  class: "txtbox"
};
const _hoisted_44 = {
  key: 0
};
const _hoisted_45 = ["innerHTML"];
const _hoisted_46 = {
  class: "funbox"
};
const _hoisted_47 = ["src"];
const _hoisted_48 = {
  class: "sharecode"
};
const _hoisted_49 = {
  class: "qrcode-share",
  ref: "qrcode-share"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CaretRight = _resolveComponent("CaretRight");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_VideoCamera = _resolveComponent("VideoCamera");
  const _component_Share = _resolveComponent("Share");
  const _component_el_button = _resolveComponent("el-button");
  const _component_Close = _resolveComponent("Close");
  return _openBlock(), _createElementBlock("div", null, [_ctx.$attrs.popshowflag && $data.detail.id ? (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["popcontainer-style1", [{
      'leftTop': $data.leftTopflag
    }, {
      'mobile': _ctx.$attrs.isMobile
    }]]),
    ref: "popContainer",
    key: $data.detail.id,
    style: _normalizeStyle($options.popContainerStyle)
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$data.detail.thumb && $data.detail.thumb.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
    src: $data.detail.thumb[0].fileUrl,
    alt: ""
  }, null, 8, _hoisted_4)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("h2", _hoisted_6, _toDisplayString($data.detail.title), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("span", _hoisted_7, "类别1：" + _toDisplayString($data.detail.category), 1)]), _createElementVNode("li", null, [_createElementVNode("span", _hoisted_8, "批次：" + _toDisplayString($data.detail.batch), 1)]), _createElementVNode("li", null, [_createElementVNode("span", _hoisted_9, "申报地区或单位：" + _toDisplayString($data.detail.address) + ", " + _toDisplayString($data.detail.protection_unit), 1)])])])]), _createElementVNode("a", {
    class: "more",
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.bigDialogOpen && $options.bigDialogOpen(...args), ["stop"]))
  }, _cache[7] || (_cache[7] = [_createTextVNode("查看详情"), _createElementVNode("i", {
    class: "icon-arrow-bottom1"
  }, null, -1)]))])], 6)) : _createCommentVNode("", true), $data.bigDialog && $data.detail.id ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["popcontainer-style4", `width${_ctx.$attrs.bodywidth}`])
  }, [_createElementVNode("div", {
    class: "popbg",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.bigDialogClose && $options.bigDialogClose(...args))
  }), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("h2", _hoisted_13, _toDisplayString($data.detail.title), 1)]), _createElementVNode("div", {
    class: "closediv",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.bigDialogClose && $options.bigDialogClose(...args))
  }, _cache[8] || (_cache[8] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)]))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.popLeftArr, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [item.flag ? (_openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': $data.popLeftIndex === item.id
      }),
      key: index,
      onClick: $event => $options.popLeftHandle(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_16)) : _createCommentVNode("", true)], 64);
  }), 256))])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
    class: _normalizeClass(["innerbox", {
      'active': $data.popLeftIndex === 0
    }])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["imgcontent", {
      'noimg': !$data.detail.thumb || $data.detail.thumb.length === 0
    }])
  }, [$data.detail.thumb && $data.detail.thumb.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("img", {
    src: $options.getImg($data.detail.thumb[0]),
    alt: ""
  }, null, 8, _hoisted_19)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [_createElementVNode("h3", null, _toDisplayString($data.detail.title), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, "编号：" + _toDisplayString($data.detail.identifier), 1), _createElementVNode("li", null, "类别：" + _toDisplayString($data.detail.category), 1), _createElementVNode("li", null, "级别：" + _toDisplayString($data.detail.level), 1), _createElementVNode("li", null, "批次：" + _toDisplayString($data.detail.batch), 1)])])], 2), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
    class: "infodesc",
    innerHTML: $data.detail.introduce
  }, null, 8, _hoisted_22)])], 2), _createElementVNode("div", {
    class: _normalizeClass(["innerbox", {
      'active': $data.popLeftIndex === 1
    }])
  }, [_createElementVNode("ul", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.person, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'noimg': item.itemformdata.thumb.length === 0
      }),
      key: index,
      onClick: $event => $options.openUrl(item.itemformdata.detailUrl)
    }, [item.itemformdata.thumb.length ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("img", {
      src: $options.getImg(item.itemformdata.thumb[0]),
      alt: ""
    }, null, 8, _hoisted_26)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [_createElementVNode("h3", null, _toDisplayString(item.itemformdata.name), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, "性别：" + _toDisplayString(item.itemformdata.sex), 1), _createElementVNode("li", null, "出生日期：" + _toDisplayString(item.itemformdata.birthday), 1), _createElementVNode("li", null, "民族：" + _toDisplayString(item.itemformdata.nation), 1), _createElementVNode("li", null, "类别：" + _toDisplayString(item.itemformdata.category), 1)])]), item.itemformdata.introduce ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "descbox",
      innerHTML: item.itemformdata.introduce
    }, null, 8, _hoisted_28)) : _createCommentVNode("", true)], 10, _hoisted_24);
  }), 128))])], 2), _createElementVNode("div", {
    class: _normalizeClass(["innerbox", {
      'active': $data.popLeftIndex === 2
    }])
  }, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.picture, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      src: $options.setBigPicture(item)
    }, null, 8, _hoisted_32)]);
  }), 128))])], 512)]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.picture, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      src: $options.setSmallPicture(item)
    }, null, 8, _hoisted_36)]);
  }), 128))])], 512)])], 2), _createElementVNode("div", {
    class: _normalizeClass(["innerbox", {
      'active': $data.popLeftIndex === 3
    }])
  }, [_createElementVNode("div", _hoisted_37, [_withDirectives(_createElementVNode("div", {
    class: "playicon",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.changevideo && $options.changevideo(...args))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CaretRight)]),
    _: 1
  })], 512), [[_vShow, $data.playiconshow]]), _createElementVNode("video", {
    id: "video",
    ref: "videoDom",
    src: $data.videoitem.url,
    controls: ""
  }, null, 8, _hoisted_38)]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.videoList, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_VideoCamera)]),
      _: 1
    })]);
  }), 128))])], 512)])], 2), _createElementVNode("div", {
    class: _normalizeClass(["innerbox", {
      'active': $data.popLeftIndex === 4
    }])
  }, [_createElementVNode("ul", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.seminarList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, [_createElementVNode("div", _hoisted_43, [_createElementVNode("h3", null, _toDisplayString(item.itemformdata[4]), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, "场馆面积（㎡）：" + _toDisplayString(item.itemformdata[9]), 1), item.itemformdata[7].length > 0 ? (_openBlock(), _createElementBlock("li", _hoisted_44, "场馆地址：" + _toDisplayString(item.itemformdata[7][0].address), 1)) : _createCommentVNode("", true), _createElementVNode("li", null, "联系电话：" + _toDisplayString(item.itemformdata[11]), 1)])]), item.introduce ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "descbox",
      innerHTML: item.introduce
    }, null, 8, _hoisted_45)) : _createCommentVNode("", true)]);
  }), 128))])], 2)])]), _createElementVNode("ul", _hoisted_46, [$data.detail.correlation_address && $data.detail.correlation_address.length > 0 ? (_openBlock(), _createElementBlock("li", {
    key: 0,
    class: "li1",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.goLocation && $options.goLocation(...args))
  }, _cache[9] || (_cache[9] = [_createElementVNode("a", null, [_createElementVNode("span", {
    class: "icon-location"
  }), _createTextVNode("导航")], -1)]))) : _createCommentVNode("", true), $data.detail.detailUrl !== '' ? (_openBlock(), _createElementBlock("li", {
    key: 1,
    class: "li2",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.getCode && $options.getCode(...args))
  }, [_createElementVNode("a", null, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Share)]),
    _: 1
  }), _cache[10] || (_cache[10] = _createTextVNode("分享"))])])) : _createCommentVNode("", true)])])], 2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("iframe", {
    id: "popiframe",
    src: $data.iframeurl,
    frameborder: "0"
  }, null, 8, _hoisted_47), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createVNode(_component_el_button, {
    class: "goback",
    onClick: $options.goback,
    round: ""
  }, {
    default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("返回")])),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createElementVNode("div", _hoisted_48, [_createElementVNode("div", {
    class: "codetop",
    onClick: _cache[6] || (_cache[6] = $event => $data.ewmflag = false)
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Close)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_49, null, 512)], 512), [[_vShow, $data.ewmflag]])]);
}